/**
 * Opções de status para formulário de Praças
 */
export const PRACA_STATUS_OPTIONS = [
  { value: 'DISPONIVEL', label: 'Disponível para adoção' },
  { value: 'EM_PROCESSO', label: 'Em processo de adoção' },
  { value: 'ADOTADA', label: 'Adotada' },
];

/**
 * Opções de status para filtro de Praças
 */
export const PRACA_FILTER_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'DISPONIVEL', label: 'Disponíveis' },
  { value: 'EM_PROCESSO', label: 'Em Processo' },
  { value: 'ADOTADA', label: 'Adotadas' },
];
